var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 45,
    viewBox: "0 0 130 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41295",
    "data-name": "Path 41295",
    d: "M125.185,45H4.815C2.119,45,0,42.525,0,39.375V5.625C0,2.475,2.119,0,4.815,0h120.37C127.881,0,130,2.475,130,5.625v33.75C130,42.525,127.881,45,125.185,45Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTriangle);
export default __webpack_public_path__ + "static/media/whiteTriangle.c18a70f5bdc9274366b67ed326bf3d68.svg";
export { ForwardRef as ReactComponent };